import { getToday, oneYearBefore } from '@/utils/formatTime';

export const defaultValuesIRMarketEnvironment = {
  currency: 1,
  irIndex: 78,
  years: 7,
  swapTenors: [],
  startDate: '',
  endDate: '',
  runDates: [''],
  frequency: 3,
  hairyChart: false,
  hairyChartLookbackYears: 5,
};

export const defaultValuesDebtHedgeSchedule = {
  companyEntity: null,
  debts: '',
  trades: '',
  debtStartDate: '',
  debtEndDate: '',
  frequency: 'Quarterly',
  amortRate: 0,
  notionalCurrency: null,
  notionalAmount: 0,
  runDate: getToday(),
  hedgePercentage: '0.50,0.75',
  hedgeStartDate: oneYearBefore(),
  hedgeEndDate: getToday(),
};

export const defaultValuesCashflowThroughTime = {
  dayCount: 360,
  companyEntity: null,
  debts: '',
  trades: '',
  runDate: '',
  modelRate: 3.8,
  preHedgeDates: '2026-11-07,2026-12-15',
  closingDate: '2027-03-31',
};

export const frequencyOptions = [
  { value: 'Annual', label: 'Annual' },
  { value: 'Semi-annual', label: 'Semi-Annual' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Monthly', label: 'Monthly' },
];

export const DEBT_TYPE_FIXED = 1;
export const DEBT_TYPE_FLOAT = 2;

export const debtTypeOptions = [
  { value: DEBT_TYPE_FLOAT, label: 'Float' },
  { value: DEBT_TYPE_FIXED, label: 'Fixed' },
];

// Months per accrual period, keyed by frequency option value.
export const frequencyMonths: Record<string, number> = {
  Annual: 12,
  'Semi-annual': 6,
  Quarterly: 3,
  Monthly: 1,
};

export const SAVE_USER_WIDGET_DATA_MODAL_ID = 'save_user_widget_data_modal_id';
